/* ------------------------------------------------------------
   INCIPIT — Hero Reveal  (Section 1/2)
   Déclenche l'animation du titre à l'entrée dans le viewport.
   - Progressif : sans JS, tout le contenu reste visible.
   - Respecte prefers-reduced-motion.
   - Compatible éditeur de thème (shopify:section:load).
   ------------------------------------------------------------ */

(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (root.dataset.ihrInit === 'true') return;
    root.dataset.ihrInit = 'true';

    var animEnabled = root.dataset.anim === 'true';

    if (!animEnabled || REDUCED || !('IntersectionObserver' in window)) {
      root.querySelectorAll('[data-ihr-reveal]').forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    // Arme les états "cachés" (uniquement maintenant que le JS est là).
    root.classList.add('incipit-anim');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);

          // Nettoie will-change une fois l'animation terminée.
          var words = entry.target.querySelectorAll('.incipit-hr__word');
          var last = words[words.length - 1];
          if (last) {
            last.addEventListener(
              'transitionend',
              function () {
                words.forEach(function (w) {
                  w.style.willChange = 'auto';
                });
              },
              { once: true }
            );
          }
        });
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    root.querySelectorAll('[data-ihr-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    // Filet de sécurité : révèle le contenu visible après 4s
    // si l'observer ne s'est pas déclenché.
    setTimeout(function () {
      root.querySelectorAll('[data-ihr-reveal]:not(.is-inview)').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('is-inview');
        }
      });
    }, 4000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-incipit-hero]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();